// extracted by mini-css-extract-plugin
module.exports = {"card":"PayEarnings_card__3ksUn"};